import styles from "./CaseStudyModal.module.scss";
import { CloseOutlined } from "@ant-design/icons";

const CaseStudyModal = ({ open, onClose, children }) => {
  if (!open) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.modalContent}>
          <button
            className={styles.closeBtn}
            onClick={onClose}
          >
            <CloseOutlined />
          </button>

          {children}
        </div>
      </div>
    </div>
  );
};

export default CaseStudyModal;